var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.00001H3M8 5.00001V3.00001M16 5V3M5 4.00001H4.9C3.85066 4.00001 3 4.85067 3 5.90001V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V5.90001C21 4.85067 20.1493 4.00001 19.1 4.00001H19M11 4.00001H13M15.253 12.1109L11.8802 16.3122C11.5075 16.7765 10.8143 16.8143 10.3933 16.3933L9 15",
    stroke: "#665C73",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.9550c68ee9b41e84c638ba758a77d7be.svg";
export { ForwardRef as ReactComponent };